/* eslint-disable */
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// slices
// import mailReducer from './slices/mail';
import chatReducer from './slices/chat';
// import productReducer from './slices/product';
// import calendarReducer from './slices/calendar';
// import kanbanReducer from './slices/kanban';

import shopsReducer from './slices/shops';
import referalsReducer from './slices/referals';
import { courseReducer } from '../modules/course-creator';
import { pageCreatorReducer } from '../modules/page-creator';
import formsReducer from './slices/forms';
import ordersReducer from './slices/orders';
import funnelStatsReducer from './slices/funnel_stats';
import reportsReducer from './slices/reports';
import uploadysReducer from './slices/uploadys';
import notifyReducer from './slices/notify';
import botReducer from './slices/bot';

// ----------------------------------------------------------------------

export const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

// export const productPersistConfig = {
//   key: 'product',
//   storage,
//   keyPrefix: 'redux-',
//   whitelist: ['sortBy', 'checkout'],
// };

const rootReducer = combineReducers({
  // mail: mailReducer,
  chat: chatReducer,
  shops: shopsReducer,
  referals: referalsReducer,
  course: courseReducer,
  pageCreator: pageCreatorReducer,
  uploadys: uploadysReducer,
  forms: formsReducer,
  orders: ordersReducer,
  funnel_stats: funnelStatsReducer,
  reports: reportsReducer,
  notify: notifyReducer,
  bot: botReducer,
  // calendar: calendarReducer,
  // kanban: kanbanReducer,
  // product: persistReducer(productPersistConfig, productReducer),
});

export default rootReducer;
